export const Activities = (props) => {
  return (
    <div id='activities' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Activities</h2>
          <p>
            We aim to create a supportive community of people trying to have a positive impact in their lives. In practice, we do this by meeting biweekly to engage with interesting content and to have fruitful discussions.
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  {' '}
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
